import React from 'react'
import { useParams } from 'react-router-dom'

import reactQuery from '../../_helpers/reactQuery'
import { filterService } from '../../_services'
import {
  HOMEPAGE_FIELDS,
  LOCAL_BUSINESS_FIELDS,
  SLIDE_FIELDS,
} from '../../constants/fieldGroups.constant'
import typeConstant from '../../constants/types.constant'
import AbstractCollection from '../Abstract/AbstractCollection'
import AbstractDocument from '../Abstract/AbstractDocument'

const Service = function () {
  const singleQueryKey = 'filter'
  const params = useParams()
  const getQuery = reactQuery.getOneQuery(
    singleQueryKey,
    params.id,
    filterService.get
  )
  return (
    <>
      <AbstractDocument
        singleCollectionName="Service"
        notToShow={[
          'ancestorIds',
          'parentId',
          'type',
          ...SLIDE_FIELDS,
          ...HOMEPAGE_FIELDS,
          ...LOCAL_BUSINESS_FIELDS,
        ]}
      />
      <AbstractCollection
        collectionName="Services"
        singleCollectionName="Service"
        notToShow={[
          'ancestorIds',
          'parentId',
          'videos',
          'type',
          'createdAt',
          ...SLIDE_FIELDS,
          ...HOMEPAGE_FIELDS,
          ...LOCAL_BUSINESS_FIELDS,
        ]}
        toShow={['name', 'coverPhoto', 'createdAt']}
        type={typeConstant.SERVICES}
        parentId={getQuery.data ? getQuery.data.id : null}
        ancestorIds={
          getQuery.data
            ? `${
                getQuery.data.ancestorIds.length
                  ? `${getQuery.data.ancestorIds.join('')},`
                  : ''
              }${getQuery.data.id}`
            : null
        }
        navigate={['services', '_id']}
      />
    </>
  )
}
export default Service
